<template>
<div class="w-100">
    <!-- no recipients availible -->
    <div
        v-if  = "!recipients"
        class = "lm-border pa-3 error white--text"
    >
        <v-icon
            size="22"
            color="white"
        >
            mdi-alert
        </v-icon>
        <span
            class="recipients-missing">Keine {{ type }}
        </span>
    </div>
    <!-- no recipients availible -->

    <!-- recipients selection -->
    <v-autocomplete
        v-if              = "recipients"
        v-model           = "selected"
        :items            = "recipients"
        item-value        = "id"
        item-text         = "name"
        :label            = "type"
        @change           = "onSelected"
        autocomplete      = "off"
        autocorrect       = "off"
        autocapitalize    = "off"
        spellcheck        = "false"
        :background-color = "collective ? 'field-group-background-blue' : ''"
        auto-select-first
        hide-details
        return-object
        clearable
    >
        <template v-slot:item="data">
            <div class="mt-2 mb-2" style="width: 600px">
                <div class="v-flex">
                    <div style="padding-top: 1px;">{{ data.item.name }}</div>
                </div>
                <div class="v-flex">
                    <div style="font-size: 13px">{{ data.item.nameAdd }}</div>
                </div>
                <div style="font-size: 13px">
                    {{ data.item.street }} {{ data.item.zip }}  {{ data.item.city }}
                </div>
            </div>
        </template>
    </v-autocomplete>
    <!-- recipients selection -->

    <!-- info of selected recipient -->
    <div
        :style = "collective ? 'background-color: aliceblue' : ''"
        class  = "pl-1 pb-2"
    >
        <div class="pt-2"></div>
        <div style="font-size: 13px"  v-if="selected != null">
            {{ selected.nameAdd }}
        </div>
        <div style="font-size: 13px"  v-if="selected != null">
            {{ selected.street }}
        </div>
        <div style="font-size: 13px"  v-if="selected != null">
            {{ selected.zip }}  {{ selected.city }}
        </div>
    </div>
    <!-- info of selected recipient -->
</div>

</template>

<script>
export default {
    name: "PIncInvoiceRecipient",

    components: {
    },

    props: {
        value: {

        },

        type: {

        },

        recipients: {

        },

        usage: {

        },

        separated: {

        },

        collective: {
            required: false,
            type     : Boolean,
            default  : function () {
                return false;
            }
        },
    },

    data: () => ({
        menu: false,
        selected: null,
    }),

    mounted() {
        this.refresh();
    },

    watch: {
        recipients () {
            this.refresh();
        }
    },

    methods: {
        onSelected () {
            this.menu = false;
            this.$emit("input", this.selected);
        },

        refresh () {
            if (!this.value && this.recipients) {
                if (this.separated) {
                    const usageRecipient = this.recipients.filter (r => r.usage === this.usage);
                    if (usageRecipient.length === 1) {
                        this.$nextTick(() => {
                            this.selected = usageRecipient [0];
                            this.$emit("input", this.selected);
                        })
                    }
                } else {
                    if (this.recipients.length === 1) {
                        this.$nextTick(() => {
                            this.selected = this.recipients [0];
                            this.$emit("input", this.selected);
                        })
                    }
                }
            }

            if (this.recipients && this.value) {
                this.selected = this.recipients.find(r => r.id === this.value.id);
            }
        }
    }
}
</script>

<style scoped>

.recipient-info {
    width: 100%;
    border-style: solid;
    border-width: 1px;
    border-color: lightgrey;
    padding: 10px;
    border-radius: 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-height: 80px;
}

.recipient-title {
    font-size: 11pt;
    padding-right: 10px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.recipient-subtitle {
    font-size: 9pt;
}

.recipient-button {
    text-transform: none;
    letter-spacing: unset;
    padding-left: 0!important;
    font-weight: normal;
}

.recipients-missing {
    font-size: 15px;
    margin-left: 8px;
    margin-top: 4px;
}

::v-deep .v-label--active {
    max-width: 133%;
    transform: translateY(-22px) scale(.75);
    pointer-events: auto;
}

</style>